/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { PureComponent } from 'react';
import moment from 'moment';
import Submit from './components/Submit';
import ResourceSelect from './components/ResourceSelect';
import Alert from '../components/Alert';
import Spinner from '../components/Spinner';
import DurationSelect from './components/DurationSelect';
import ProductOptions from './components/ProductOptions.js';
import RentalDatePicker from '../components/RentalDatePicker';

import { capitalize } from '../utilities/helperUtility';
import Translation from '../utilities/localizationUtility';
import { stringToBoolean } from '../utilities/conversionUtility';

import { SHORT_DATE_FORMAT } from '../constants';

const styles = {
  formGroupContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '6px 0',
    justifyContent: 'space-between',
  },
  labelText: {
    fontSize: '16px',
    padding: '4px 0',
  },
  inputStyle: {
    flex: '1',
    padding: '5px',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  formGroup: {
    flexGrow: '1',
    display: 'flex',
    padding: '0 4px 0 0',
    flexDirection: 'column',
  },
  inputGroup: {
    display: 'flex',
  },
};

/**
 * check if a date array contains `date` inside.
 * @param {Array} blackoutsArr - blackout array
 * @param {Date} date - date to compare
 * @returns {Boolean} true if one of blackoutsArr's elements contains date inside, false if otherwise.
 * */
function isDateInDateRange(dateArr, date) {
  return dateArr && dateArr.some(dateElement => moment(new Date(date).setHours(0, 0, 0, 0, 0))
    .isBetween(new Date(dateElement.start).setHours(0, 0, 0, 0),
      new Date(dateElement.finish).setHours(0, 0, 0, 0), null, '[]'));
}

/**
 * Get days between two dates.
 * @param {Date} startDate - Start date
 * @param {Date} endDate - End Date.
 */
function enumerateDaysBetweenDates(startDate, endDate) {
  const dates = [];
  const now = moment(startDate).clone();
  let newNow = now;
  while (newNow.isSameOrBefore(endDate)) {
    dates.push(now.toDate());
    newNow = now.add(1, 'days');
  }
  return dates;
}

export default class RentalPage extends PureComponent {
  state = {
    start: null,
    duration: 0,
    finish: null,
    enteredTo: null,
    durationValue: 0,
    hoverStart: null,
    daySelected: null,
    selectedOptions: {},
    // Range select
    hoverEnteredTo: null,
    remainingCapacity: 0,
    variantExternalId: null,
    currentMonth: moment(Date.now()),
  };

  constructor(props) {
    super(props);
    this.onSubmitBound = this.onSubmit.bind(this);
    this.onDayClickBound = this.onDayClick.bind(this);
    this.onMonthClickBound = this.onMonthClick.bind(this);
    this.handleDayMouseEnterBound = this.handleDayMouseEnter.bind(this);
    this.handleDayMouseLeaveBound = this.handleDayMouseLeave.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { options } = this.props;
    const selectedOptions = options.reduce((obj, option) => ({ ...obj, [option.name]: option.values[0] }), {});
    this.setState({ selectedOptions }, () => {
      Object.entries(selectedOptions).forEach(([name, value]) => this.handleProductOptions(name, value, true));
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if ((nextProps.order.selectedResource || {}).id !== (this.props.order.selectedResource || {}).id) {
      const { selectedOptions } = this.state;
      const [first] = Object.entries(selectedOptions || {});

      if (first && first[0]) {
        setTimeout(() => this.handleProductOptions(first[0], first[1], true, nextProps), 1000);
      }
    }
  }

  componentDidMount() {
    const {
      bookings,
      capacity,
      durations,
      currentMonth,
      frameActions: {
        fetchBlocks,
      },
    } = this.props;
    const { variantExternalId } = this.state;
    if (this.spinner) this.spinner.show();
    fetchBlocks(variantExternalId, currentMonth, moment(currentMonth).endOf('month').format('YYYY-MM-DD'));
    this.updateBookings(bookings);
    const newCapacity = capacity.type === 'product' ? capacity.capacity : 0;
    this.setState({
      remainingCapacity: newCapacity,
      durationValue: durations.type === 'product' ? durations.duration : 0,
      duration: durations.type === 'product' ? durations.duration / 86400 : 0,
    });
  }

  // select day event.
  onDayClick(day) {
    const { duration } = this.state;

    const {
      lagTime,
      leadTime,
      blackouts,
      timeslots,
      availableBlocks,
      nonAvailableBlocks,
      orderActions: { setDateRange },
    } = this.props;

    const selectedDay = moment(day).startOf('day');
    const leadLagSum = lagTime + leadTime;

    const selectDay = {
      start: selectedDay.toDate(),
      daySelected: selectedDay.toDate(),
      finish: selectedDay.clone().add(duration, 'days').add(-1, 'seconds').toDate(),
      enteredTo: selectedDay.clone().add(duration, 'days').add(-1, 'seconds').toDate(),
    };

    const availableBlock = availableBlocks.find(block => moment(block.date).isSame(day, 'date'));
    const selectedRange = availableBlock ? {
      start: moment(availableBlock.date).toDate(),
      finish: moment(availableBlock.date).add(duration, 'days').toDate(),
    } : {};
    // if selected day is a blackout block then return.
    if (blackouts.length > 0 && blackouts.find(
      blackout => moment(blackout.date).isSame(selectDay.start, 'date'),
    )) return;

    // if selected day is a booked block then return.
    if (timeslots && timeslots.find(
      block => block.timeslots[0].status === 3
        && isDateInDateRange([{
          start: moment(block.date).subtract(leadLagSum, 'days').toDate(),
          finish: moment(block.date).add(leadLagSum, 'days').toDate(),
        }], selectDay.start),
    )) return;

    // If client clicks on a non available block then return.
    if (nonAvailableBlocks.some(nBlock => moment(nBlock).isSame(day, 'date'))) return;

    // if selected day is a previous day of today then return.
    if (moment(new Date(Date.now())).isAfter(new Date(day).setHours(0, 0, 0, 0), 'day')) return;

    setDateRange({
      start: selectedRange.start,
      finish: selectedRange.finish,
      duration,
    });

    this.setState(selectDay);
  }

  onSubmit(e) {
    const messages = [];
    const ele = e.target;
    const { orderActions, cartActions } = this.props;
    orderActions
      .submitRentalOrder()
      .then((response) => {
        const { reservation } = response.data;
        if (reservation.items.some(x => x.status !== 'ok')) {
          let m = 'SCHEDULE CONFLICT PLEASE RELOAD PAGE';

          if (window.screen.width < 380) m = 'PLEASE RELOAD PAGE';
          this.alert.show('red', [m]);
          ele.innerText = m;
        } else {
          cartActions.addItems(reservation, ['Start']);
        }
      })
      .catch((responsed) => {
        ele.disabled = false;
        const { response } = responsed;
        if (response && response.data) {
          const { data } = response;
          Object.keys(data).forEach((key) => {
            const name = key
              .split('_')
              .map(x => capitalize(x))
              .join('');
            messages.push(`${name} ${data[key]}`);
          });

          this.alert.show('red', ['SERVER ERROR']);
        } else {
          this.alert.show('red', ['SOMETHING WRONG']);
          throw responsed;
        }
      });
  }

  updateBookings = (bookings, variantId) => {
    const { order: { variantSelected } } = this.props;
    const bookedVariants = bookings && bookings
      .filter(booking => booking.external_id === variantId);
    const newBookedDays = bookedVariants && bookedVariants.filter(e => e.items
      .find(item => (item.variant_id === variantSelected.id)
        && (variantSelected.id) && item.quantity - variantSelected.capacity === 0))
      .map(el => ({ start: el.starts_at, finish: el.finishes_at }));
    this.setState({
      bookedDays: newBookedDays,
    });
  }

  onMonthClick = (day) => {
    const {
      bookings,
      order: preOrder,
      setting: { interval },
      frameActions: { fetchBlocks, setCurrentMonth },
    } = this.props;
    const date = moment(day);
    const start = moment([date.year(), date.month()]);
    const finish = moment(start).endOf('month');

    setCurrentMonth(date);
    this.updateBookings(bookings, preOrder.variantSelected && preOrder.variantSelected.external_id);
    this.setState({ currentMonth: moment(day) });
    if (this.spinner) this.spinner.show();
    fetchBlocks(
      preOrder.variantSelected ? preOrder.variantSelected.external_id : null,
      start,
      finish,
      preOrder.selectedLocation ? preOrder.selectedLocation.id : null,
      preOrder.selectedResource ? preOrder.selectedResource.id : null,
      interval,
    );
  };

  handleResetClick() {
    this.setState({
      start: null,
      finish: null,
      enteredTo: null,
    });
  }

  handleDayMouseEnter(day) {
    const { duration } = this.state;
    const {
      lagTime,
      leadTime,
      timeslots,
      availableBlocks,
    } = this.props;
    const d = duration - 1;
    const leadLagSum = leadTime + lagTime;
    // if hovered day is a booked block then return.
    if (timeslots && timeslots.find(
      block => block.timeslots[0].status === 3
            && isDateInDateRange([{
              start: moment(block.date).subtract(leadLagSum, 'days').toDate(),
              finish: moment(block.date).add(leadLagSum, 'days').toDate(),
            }], day),
    )) return;
    const dayBlock = availableBlocks
      .map(block => ({
        start: moment(block.date).toDate(),
        finish: moment(block.date).add(d, 'days').toDate(),
      }))
      .find(block => moment(block.start).isSame(day, 'date'));
    if (dayBlock) {
      this.setState({
        hoverStart: dayBlock.start,
        hoverEnteredTo: dayBlock.finish,
      });
    }
  }

  handleDayMouseLeave() {
    this.setState({
      hoverStart: null,
      hoverEnteredTo: null,
    });
  }

  handleProductOptions = (option, value, init = false, props) => {
    const newState = {
      start: null,
      finish: null,
      enteredTo: null,
    };

    let newSelectedVariant = null;
    const selectedObj = { [option]: value };
    const {
      bookings,
      capacity,
      variants,
      durations,
      setting: { interval },
      frameActions: { fetchBlocks },
      orderActions: { setSelectedVariant },
      order: { selectedResource, selectedLocation },
    } = props || this.props;
    const { selectedOptions, durationValue, currentMonth } = this.state;
    if (selectedOptions[option] === value && !init) return;
    selectedOptions[option] = value;

    if (durations.type === 'variant_option' && durations.option === option) {
      newState.durationValue = durations.durations.find(d => d.value === selectedObj[durations.option]).duration;
      this.setState({ durationValue: newState.durationValue, duration: newState.durationValue / 86400 });
    }

    if (capacity.type === 'product') {
      newState.remainingCapacity = capacity.capacities;
    } else {
      const variantCapacity = Object.values(selectedOptions).reduce((obj, item, index) => {
        const newObj = { ...obj };

        newObj.variant = index ? (newObj.variant || {})[item] : variants[item];

        if (capacity.type === 'variant_option') {
          newObj.capacity = index ? (newObj.capacity || {})[item] : capacity.capacities[item];
        } else if (capacity.type === 'resource' && selectedResource) {
          newObj.capacity = capacity.capacities[selectedResource.name];
        }
        return newObj;
      }, { variant: {}, capacity: {} });

      newSelectedVariant = variantCapacity.variant;
      newState.remainingCapacity = (variantCapacity.capacity || {}).capacity || 0;
    }

    if (newSelectedVariant) {
      setSelectedVariant(newSelectedVariant);
      this.updateBookings(bookings, newSelectedVariant.external_id);
      fetchBlocks(
        newSelectedVariant.external_id || '',
        currentMonth.startOf('month').format(SHORT_DATE_FORMAT),
        currentMonth.endOf('month').format(SHORT_DATE_FORMAT),
        selectedLocation ? selectedLocation.id : null,
        selectedResource ? selectedResource.id : null,
        interval,
      );

      newState.variantExternalId = newSelectedVariant.external_id;
    } else if (this.alert) {
      if (capacity.type === 'variant_option') {
        this.alert.show('red', ['Chosen variant is not available at the moment, please choose another one.']);
      }
    }

    if (capacity.type === 'resource') {
      if (this.alert && !selectedResource) this.alert.show('red', ['Please choose product resource']);
      else newState.capacity = selectedResource ? selectedResource.inventory : 0;
    }

    if (this.spinner) this.spinner.show();

    newState.selectedOptions = selectedOptions;

    if (newState.durationValue !== undefined) {
      newState.duration = newState.durationValue / 86400;
    }

    this.setState(newState);
  }

  render() {
    const {
      style,
      options,
      setting,
      lagTime,
      capacity,
      leadTime,
      timeslots,
      blackouts,
      // translation,
      isFetchingBlocks,
      nonAvailableBlocks,
      order: { variantSelected },
    } = this.props;

    const {
      start,
      finish,
      enteredTo,
      hoverStart,
      daySelected,
      durationValue,
      hoverEnteredTo,
      selectedOptions,
      remainingCapacity,
    } = this.state;

    const leadLagSum = leadTime + lagTime;
    const t = new Translation(this.props);
    const disabledDays = {
      // before today.
      beforeToday: new Date(Date.now()),
    };
    const daysBetween = enumerateDaysBetweenDates(hoverStart, hoverEnteredTo);
    const blackoutsArr = blackouts.map(blackout => ({
      start: moment(blackout.date).toDate(),
      finish: moment(blackout.date).toDate(),
    }));

    return (
      <div style={{ ...style.body, maxWidth: '450px', minHeight: 635 }}>
        <ProductOptions
          options={options}
          defaultOptions={Object.values(selectedOptions)}
          styles={{ optionsStyle: style.button }}
          onActiveCallback={this.handleProductOptions}
        />
        <div style={{ marginBottom: '10px' }}>
          <DurationSelect
            onDurationChange={() => {}}
            durations={[Math.round(durationValue * 100 / 86400) / 100]}
          />
          {capacity.type === 'resource' && <ResourceSelect className="mt15" onResourcesChanged={this.onResourcesChanged} />}
        </div>
        <Spinner ref={ref => (this.spinner = ref)} />
        <RentalDatePicker
          to={finish}
          from={start}
          setting={setting}
          enteredTo={enteredTo}
          hoverStart={hoverStart}
          disabledDays={disabledDays}
          hoverEnteredTo={hoverEnteredTo}
          onDayClick={this.onDayClickBound}
          onMonthChange={this.onMonthClickBound}
          handleDayMouseEnter={this.handleDayMouseEnterBound}
          handleDayMouseLeave={this.handleDayMouseLeaveBound}
          innerRef={ref => (this.dayPicker = this.dayPicker || ref)}
          isDisableCalendar={
            // disable calendar while fetching blocks
            isFetchingBlocks
            // disable calendar when duration value equals to 0
            || durationValue === 0
            // disable calendar when remaining capacity equals to 0
            // (when capacity types are variant_option and resource)
            || remainingCapacity === 0
          }
          styled={{ datepicker: style.datepicker, buttonStyle: style.button }}
          modifiers={{
            start,
            hoverStart,
            hoverEnteredTo,
            end: enteredTo,
            selected: daySelected,
            hoverHighlight: daysBetween,
            nonAvailable: nonAvailableBlocks,
            blackoutOverlap: blackoutsArr ? blackoutsArr.map(blackoutEl => ({
              to: blackoutEl.finish,
              from: blackoutEl.start,
            })) : [],
            bookedDates: timeslots ? timeslots.map(timeslot => ({
              to: timeslot && timeslot.timeslots[0].status === 3
                && moment(timeslot.date).add(leadLagSum, 'days').toDate(),
              from: timeslot && timeslot.timeslots[0].status === 3
                && moment(timeslot.date).subtract(leadLagSum, 'days').toDate(),
            })) : [],
          }}
        />
        <br />
        <p className="text-right">
          Price:
          <span className="bold ml10" style={{ ...style.price, fontSize: '35px' }}>
            {t.key('priceSymbol')}
            {/* Get the first variant's price for development purposes. */}
            {(variantSelected && variantSelected.price ? variantSelected.price.toFixed(2) : Number(0).toFixed(2))}
          </span>
        </p>
        <div style={styles.formGroupContainer} className="form-group-container">
          <div className="form-group" style={styles.formGroup}>
            <label style={styles.labelText} className="col-sm-3 control-label">Pick up date</label>
            <div style={styles.inputGroup} className="col-sm-9">
              <input
                readOnly
                type="text"
                className="form-control"
                style={styles.inputStyle}
                value={start ? moment(start).format('DD/MM/YYYY') : ''}
              />
            </div>
          </div>
          {
            stringToBoolean(setting.include_returned_date) && (
              <div style={styles.formGroup} className="form-group">
                <label style={styles.labelText} className="col-sm-3 control-label">Return date</label>
                <div style={styles.inputGroup} className="col-sm-9">
                  <input
                    readOnly
                    type="text"
                    className="form-control"
                    style={styles.inputStyle}
                    value={finish ? moment(finish).format('DD/MM/YYYY') : ''}
                  />
                </div>
              </div>
            )}
        </div>
        <div>
          <Alert ref={ref => (this.alert = ref)} />
          <Submit onSubmit={this.onSubmitBound} className="submit" canBook={!!variantSelected && (start || finish)} />
        </div>
      </div>
    );
  }
}

RentalPage.propTypes = {};
